import { MAP_GEOMETRY_TYPE } from "./mapGeometryType";
export default {
    [MAP_GEOMETRY_TYPE.POINT]: "Метка",
    [MAP_GEOMETRY_TYPE.LINE]: "Линия",
    [MAP_GEOMETRY_TYPE.AREA]: "Область"
};
